<template>
  <v-dialog
    v-model="show"
    @click:outside="closeDialog()"
    content-class="dialoghelp"
  >
    <div class="contIcon">
      <IconInfo></IconInfo>
    </div>
    <span class="titleH">Ayuda</span>
    <span class="text">
      El formato de encarpetamiento permite crear un directorio bajo el que los
      archivos se van almacenar. Por ejemplo:
    </span>
    <span class="text">
      Formato: {ciudad} > {folio} > {status} > {@date:yyyy-MM-dd} > {formato de
      etiqueta}.mp3
    </span>
    <span class="text">
      Encarpetamiento de contenido: Bogota > 999291 > VENTA > 2020-12-08 >
      Grabacion_573104674919_0175273.mp3
    </span>
    <span class="text botLine">
      Nota: el carácter dos puntos (:) es exclusivo para {@date:yyyy-MM-dd}, mo
      se debe utilizar en otras partes del formato.
    </span>
    <div @click="closeDialog()" class="btn">
      <span>Entendido</span>
    </div>
  </v-dialog>
</template>
<script>
import IconInfo from "@/assets/iconsTaskExport/Info.svg";
export default {
  props: ["show"],
  components: {
    IconInfo,
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog", false);
    },
  },
};
</script>
<style lang="scss">
.v-dialog {
  &.dialoghelp {
    background: #ffffff;
    max-width: 450px;
    position: relative;
    padding: 10px 30px;
    border-radius: 3px;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .contIcon {
    width: 36px;
    height: 36px;
    margin: 10px 0;
  }
  .titleH {
    font-size: 25px;
    text-align: center;
    font-weight: 500;
    margin-bottom: 10px;
  }
  .text {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 12px;
    text-align: center;
    &.botLine {
      border-bottom: 1px solid #e3e4e6;
      padding: 0 0 15px 0;
    }
  }
  .btn {
    background: #3ca0f5;
    border-radius: 3px;
    padding: 6px 5px;
    width: 100%;
    max-width: 180px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin: 20px 0;
    span {
      color: #ffffff;
      font-size: 13px;
      cursor: pointer;
    }
  }
}
</style>
